import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

const buildPoints = (rows) =>
  rows
    .map((row) => ({
      ts: row.ts,
      value: Number(row.value)
    }))
    .filter((row) => Number.isFinite(row.value))
    .sort((a, b) => a.ts - b.ts);

export default function MetricChart({
  title,
  subtitle,
  rows,
  color,
  formatValue,
  formatTime,
  insight
}) {
  const points = buildPoints(rows);
  const latest = points[points.length - 1];

  const renderTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;
    const value = payload[0].value;
    return (
      <div className="chart-tooltip">
        <div className="chart-tooltip-title">{formatTime(label)}</div>
        <div className="chart-tooltip-value">{formatValue(value)}</div>
        {insight?.caption && (
          <div className="chart-tooltip-insight">
            <div>{insight.caption}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div>
          <div className="chart-title">{title}</div>
          <div className="chart-subtitle">{subtitle}</div>
          {insight?.caption && (
            <div className="chart-insight">
              <span>{insight.caption}</span>
            </div>
          )}
        </div>
        <div className="chart-value mono">
          {latest ? formatValue(latest.value) : "-"}
        </div>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={points} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="rgba(255,255,255,0.08)" strokeDasharray="4 6" />
            <XAxis
              dataKey="ts"
              tickFormatter={(ts) => formatTime(ts, true)}
              tick={{ fill: "#8ea3a0", fontSize: 11 }}
              axisLine={{ stroke: "rgba(255,255,255,0.08)" }}
              tickLine={false}
            />
            <YAxis
              tickFormatter={(value) => formatValue(value, true)}
              tick={{ fill: "#8ea3a0", fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              width={72}
            />
            <Tooltip content={renderTooltip} />
            <Line
              type="monotone"
              dataKey="value"
              stroke={color}
              strokeWidth={2.2}
              dot={false}
              activeDot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
